import { DoorStatus, DoorType, DoorUsage } from "./enums";
import { XGSSelectOption } from "../../../ui-components/xgs-select/xgsSelect";
import { SelectOption } from "../equipment/models";

export interface Door {
  terminalNumber?: number;
  doorNumber?: string;
  doorType?: DoorType;
  primaryDistributor?: string;
  doorPriority?: string;
  trailerNumber?: number;
  manifestNumber?: number;
  doorUsage?: DoorUsage;
  doorStatus?: DoorStatus;
}

export enum DoorTypeCode {
  CITY_DELIVERY = "C",
  LOADING = "L",
  OVERAGES = "O",
  RACK = "R",
  STAGING = "S",
  SHORTAGES = "T",
  UNLOADING = "U"
}

export enum DoorUsageCode {
  CITY_RACK = "C",
  LOCAL_ONLY = "L",
  MOBILE_STG = "M",
  NON_PERM = "N",
  OVERAGE = "O",
  PERMANENT = "P",
  WMS = "Q",
  SHORTAGE = "T",
  WILL_CALLS = "W",
  LOST = "Z"
}

export interface SecondaryDistributor {
  id: string;
  accountNumber: string;
  name: string;
  attention: string;
  address: string;
}

export interface AssignDoorModalProps {
  show: boolean;
  onClose: () => void;
  onSave?: (data: {
    door: string;
    carrier: string;
    trailer: string;
    priority: string;
    primaryDistributor: string;
    secondaryDistributors: SecondaryDistributor[];
    doorUsage: string;
    doorType?: string;
  }) => void;
  onBack?: () => void;
  manifestNumber?: string;
  originTerminal?: string;
  destinationTerminal?: string;
  shipmentCount?: number;
}

export interface AssignDoorFormValues {
  door: XGSSelectOption | null;
  priority: XGSSelectOption | null;
  primaryDistributor: XGSSelectOption | null;
  carrier: XGSSelectOption | null;
  trailer: XGSSelectOption | null;
  doorUsage: XGSSelectOption | null;
  doorType: XGSSelectOption | null;
}

export interface AddSecondaryDistributorModalProps {
  show: boolean;
  onClose: () => void;
  onAdd: (distributor: SecondaryDistributor) => void;
  existingDistributorIds: string[];
}

export const PRIORITY_OPTIONS: XGSSelectOption[] = [
  { label: "Medium", value: "MEDIUM" },
  { label: "High", value: "HIGH" },
  { label: "Critical", value: "CRITICAL" },
];

export const DOOR_TYPE_OPTIONS: XGSSelectOption[] = [
  { label: "City Delivery", value: DoorTypeCode.CITY_DELIVERY },
  { label: "Loading", value: DoorTypeCode.LOADING },
  { label: "Overages", value: DoorTypeCode.OVERAGES },
  { label: "Rack", value: DoorTypeCode.RACK },
  { label: "Staging", value: DoorTypeCode.STAGING },
  { label: "Shortages", value: DoorTypeCode.SHORTAGES },
  { label: "Unloading", value: DoorTypeCode.UNLOADING },
];

export const DOOR_USAGE_OPTIONS: XGSSelectOption[] = [
  { label: "City Rack", value: DoorUsageCode.CITY_RACK },
  { label: "Local Only", value: DoorUsageCode.LOCAL_ONLY },
  { label: "Mobile Staging", value: DoorUsageCode.MOBILE_STG },
  { label: "Non Permanent", value: DoorUsageCode.NON_PERM },
  { label: "Overage", value: DoorUsageCode.OVERAGE },
  { label: "Permanent", value: DoorUsageCode.PERMANENT },
  { label: "WMS", value: DoorUsageCode.WMS },
  { label: "Shortage", value: DoorUsageCode.SHORTAGE },
  { label: "Will Calls", value: DoorUsageCode.WILL_CALLS },
  { label: "Lost", value: DoorUsageCode.LOST },
];

export const statusOptions: SelectOption[] = [
  { label: "Unassigned", value: "UNASSIGNED" },
  { label: "Loading", value: "LOADING" },
  { label: "Closed", value: "CLOSED" },
  { label: "Departed", value: "DEPARTED" }
];

export const TIME_PERIOD_LIST: {
  [key: string]: string;
} = {
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  TOMORROW: "Tomorrow",
  THIS_WEEK: "This Week",
  LAST_WEEK: "Last Week",
  NEXT_WEEK: "Next Week"
};

export interface LoadboardListManifestRequestParams {
  manifestOriginTerminalNumber?: number;
  startCutDate?: Date | string;
  endCutDate?: Date | string;
  doorManifestStatus?: string[] | string;
  carrierNumber?: number;
  doorNumber?: string;
  manifestNumberSearch?: string;
  manifestDestinationTerminalNumber?: number;
}

export interface LoadboardListManifestTrip {
  carrierNumber: string;
  carrierName: string;
  destinationTerminalAirportCode: string;
  destinationTerminalNumber: any;
  destinationTerminalName: string;
  doorNumber: string;
  doorManifestStatus: string;
  driverId: string;
  driverName: string;
  originTerminalNumber: any;
  arrivalDate: any;
  dispatchTime: any;
  dispatchDate: any;
  manifestNumber: string | number;
  manifestId: string;
  door: string;
  status: string;
  destination: string;
  loadPercent: number;
  weight: number;
  pieces: number;
  eta: string;
  driver?: string;
  trailer?: string;
  plannedCloseDate?: string;
  plannedCloseTime?: string;
  originTerminalAirportCode: string;
  originTerminalName: string;
  trailerNumber: string;
  tractorNumber: string;
  tripNumber: number;
  carrier: string;
}